import type {
  ReleaseRecord,
  ServerConfig,
  SignReleaseRequest,
  SignReleaseResponse,
} from '@shared/types';

class ApiError extends Error {
  constructor(public status: number, message: string) {
    super(message);
  }
}

async function request<T>(path: string, opts: RequestInit = {}): Promise<T> {
  const headers = new Headers(opts.headers);
  if (opts.body) headers.set('Content-Type', 'application/json');
  const res = await fetch(path, { ...opts, headers });
  if (!res.ok) {
    const text = await res.text().catch(() => '');
    throw new ApiError(res.status, text || res.statusText);
  }
  return res.json() as Promise<T>;
}

export { ApiError };

export const api = {
  config: () => request<ServerConfig>('/api/config'),
  getRelease: (token: string) =>
    request<ReleaseRecord>(`/api/releases/${encodeURIComponent(token)}`),
  signRelease: (token: string, body: SignReleaseRequest) =>
    request<SignReleaseResponse>(
      `/api/releases/${encodeURIComponent(token)}/sign`,
      { method: 'POST', body: JSON.stringify(body) },
    ),
};
